export default () => {
  apos.aposForm = apos.aposForm || {};
  apos.aposForm.collectors = {};
};
